import pushid from 'pushid';
import { toArray, random, success, getRandomId, getLastId, shuffle } from '@/helpers/utils';
import cloneDeep from 'clone-deep';
import { EventBus } from '@/helpers/event-bus';
import Vue from 'vue';

export const Module = {
    state: {
        modules: [
            {
                type: 'about',
                name: 'Über uns',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['about']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: true
                },
                layout: {
                    types: [1, 2, 3, 4, 5],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme, page) => {
                        if (page === 'home') {
                            return {
                                1: 1,
                                2: 6,
                                3: 1,
                                4: 3
                            }[theme];
                        }
                        return {
                            1: 1,
                            2: 6,
                            3: 3,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U018');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('about/title'),
                        subtitle: context.getters.getRandomTextInNamespace('about/subtitle'),
                        text: context.getters.getRandomTextInNamespace('about/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/about/bg'),
                            pos: 1
                        }
                    };
                }
            },
            {
                type: 'aboutwidget',
                name: 'Über uns Übersicht',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme, page) => {
                        if (page === 'home') {
                            return {
                                1: 1,
                                2: 6,
                                3: 1,
                                4: 3
                            }[theme];
                        }
                        return {
                            1: 2,
                            2: 6,
                            3: 1,
                            4: 4
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U018');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('aboutwidget/title'),
                        subtitle: context.getters.getRandomTextInNamespace('aboutwidget/subtitle'),
                        text: context.getters.getRandomTextInNamespace('aboutwidget/text')
                    };
                },
                async afterCreation(id, context) {
                    await context.dispatch('setProp', {
                        source: 'tecpage.user.modules.' + id + '.appearance.background',
                        value: {
                            active: true,
                            image: {
                                id: context.getters.getRandomImageInNamespace('images/bg'),
                                pos: 1,
                                transparency: 85
                            }
                        }
                    });
                }
            },
            {
                type: 'album',
                name: 'Album',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: false,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right'],
                    defaultType: 1
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'flexible',
                createHelp() {
                    return Vue.helpers.uiText('U037');
                },
                data(context) {
                    let images = context.getters.getAllImagesInNamespace('images/gallery');
                    images = shuffle(images);
                    return {
                        title: 'Schreiben Sie einen Titel, der Ihr Modul am besten beschreibt',
                        subtitle: 'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                        text1: 'Fassen Sie zusammen, worum es in dem Modul geht.',
                        slides: {
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[0].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[1].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[2].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[3].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[4].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[5].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            }
                        }
                    };
                }
            },
            {
                type: 'awards',
                name: 'Auszeichnungen',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 2,
                            2: 7,
                            3: 2,
                            4: 4
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U032');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('awards/title'),
                        subtitle: context.getters.getRandomTextInNamespace('awards/subtitle'),
                        text: context.getters.getRandomTextInNamespace('awards/text')
                    };
                },
                async afterCreation(id, context) {
                    // add default data for non preset
                    let data = context.getters.getProp('deha.user.misc.awards');
                    if (data === undefined || data === null || data === '') {
                        await context.dispatch('setProp', {
                            source: 'deha.user.misc.awards',
                            value: {
                                [getRandomId()]: {
                                    id: getLastId(),
                                    visible: true,
                                    data: {
                                        name: 'Ihre Auszeichnung'
                                    }
                                }
                            }
                        });
                    }
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.awards',
                        dataPreset: null,
                        moduleId: id,
                        default: 'all'
                    });
                }
            },
            {
                type: 'brands',
                name: 'Marken',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme, page) => {
                        if (page === 'home') {
                            return {
                                1: 2,
                                2: 7,
                                3: 2,
                                4: 4
                            }[theme];
                        }
                        return {
                            1: 2,
                            2: 6,
                            3: 3,
                            4: 4
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U025');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('brands/title'),
                        subtitle: context.getters.getRandomTextInNamespace('brands/subtitle'),
                        text: context.getters.getRandomTextInNamespace('brands/text')
                    };
                },
                async afterCreation(id, context) {
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.brands',
                        dataPreset: 'Listpresets.brands',
                        moduleId: id
                    });
                }
            },
            {
                type: 'certifications',
                name: 'Zertifikate',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme, page) => {
                        if (page === 'home') {
                            return {
                                1: 2,
                                2: 7,
                                3: 3,
                                4: 4
                            }[theme];
                        } else if (page === 'about') {
                            return {
                                1: 1,
                                2: 6,
                                3: 3,
                                4: 3
                            }[theme];
                        }
                        return {
                            1: 1,
                            2: 7,
                            3: 2,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U022');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('certifications/title'),
                        subtitle: context.getters.getRandomTextInNamespace(
                            'certifications/subtitle'
                        ),
                        text: context.getters.getRandomTextInNamespace('certifications/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace(
                                'images/certifications/bg'
                            ),
                            pos: 1
                        }
                    };
                },
                async afterCreation(id, context) {
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.certifications',
                        dataPreset: 'Listpresets.certifications',
                        moduleId: id
                    });
                }
            },
            {
                type: 'contact',
                name: 'Kontakt',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: true
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme, page) => {
                        if (page === 'home') {
                            return {
                                1: 1,
                                2: 6,
                                3: 1,
                                4: 3
                            }[theme];
                        }
                        return {
                            1: 1,
                            2: 7,
                            3: 3,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U031');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('contact/title'),
                        subtitle: context.getters.getRandomTextInNamespace('contact/subtitle'),
                        text: context.getters.getRandomTextInNamespace('contact/text')
                    };
                }
            },
            {
                type: 'contactform',
                name: 'Kontaktformular',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 2,
                            2: 6,
                            3: 1,
                            4: 4
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U031');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('contactform/title'),
                        subtitle: context.getters.getRandomTextInNamespace('contactform/subtitle'),
                        text: context.getters.getRandomTextInNamespace('contactform/text'),
                        email: context.getters.getProp('deha.user.email')
                    };
                }
            },
            {
                type: 'contactwidget',
                name: 'Kontaktübersicht',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme, page) => {
                        if (page === 'home') {
                            return {
                                1: 1,
                                2: 6,
                                3: 1,
                                4: 3
                            }[theme];
                        }
                        if (page === 'about') {
                            return {
                                1: 2,
                                2: 7,
                                3: 1,
                                4: 4
                            }[theme];
                        }
                        if (page === 'sectors') {
                            return {
                                1: 1,
                                2: 7,
                                3: 1,
                                4: 3
                            }[theme];
                        }
                        if (page === 'jobs') {
                            return {
                                1: 1,
                                2: 6,
                                3: 1,
                                4: 4
                            }[theme];
                        }
                        if (page === 'references') {
                            return {
                                1: 2,
                                2: 6,
                                3: 1,
                                4: 4
                            }[theme];
                        }
                        return {
                            1: 1,
                            2: 7,
                            3: 2,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U031');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('contactwidget/title'),
                        subtitle: context.getters.getRandomTextInNamespace(
                            'contactwidget/subtitle'
                        ),
                        text: context.getters.getRandomTextInNamespace('contactwidget/text')
                    };
                }
            },
            {
                type: 'documents',
                name: 'Dokumente',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 3,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U030');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('documents/title'),
                        subtitle: context.getters.getRandomTextInNamespace('documents/subtitle'),
                        text: context.getters.getRandomTextInNamespace('documents/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/documents/bg'),
                            pos: 1
                        }
                    };
                }
            },
            {
                type: 'gallery',
                name: 'Galerie mit Textbox',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U035');
                },
                data(context) {
                    let images = context.getters.getAllImagesInNamespace('images/gallery');
                    images = shuffle(images);
                    return {
                        slides: {
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    title: context.getters.getRandomTextInNamespace(
                                        'gallery/1/title'
                                    ),
                                    subtitle: context.getters.getRandomTextInNamespace(
                                        'gallery/1/subtitle'
                                    ),
                                    text: context.getters.getRandomTextInNamespace(
                                        'gallery/1/text'
                                    ),
                                    link: null,
                                    image: {
                                        id: images[0].id,
                                        pos: 1,
                                        transparency: 10
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    title: context.getters.getRandomTextInNamespace(
                                        'gallery/2/title'
                                    ),
                                    subtitle: context.getters.getRandomTextInNamespace(
                                        'gallery/2/subtitle'
                                    ),
                                    text: context.getters.getRandomTextInNamespace(
                                        'gallery/2/text'
                                    ),
                                    link: null,
                                    image: {
                                        id: images[1].id,
                                        pos: 1,
                                        transparency: 10
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    title: context.getters.getRandomTextInNamespace(
                                        'gallery/3/title'
                                    ),
                                    subtitle: context.getters.getRandomTextInNamespace(
                                        'gallery/3/subtitle'
                                    ),
                                    text: context.getters.getRandomTextInNamespace(
                                        'gallery/3/text'
                                    ),
                                    link: null,
                                    image: {
                                        id: images[2].id,
                                        pos: 1,
                                        transparency: 10
                                    }
                                }
                            }
                        }
                    };
                }
            },
            {
                type: 'imageslider',
                name: 'Galerie',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs']
                    },
                    onceOverall: false,
                    onceOnCurPage: false,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: []
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'flexible',
                createHelp() {
                    return Vue.helpers.uiText('U023');
                },
                data(context) {
                    let images = context.getters.getAllImagesInNamespace('images/gallery');
                    images = shuffle(images);
                    return {
                        slides: {
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[0].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[1].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                visible: true,
                                data: {
                                    image: {
                                        id: images[2].id,
                                        pos: 1,
                                        transparency: 0
                                    }
                                }
                            }
                        }
                    };
                }
            },
            {
                type: 'imagetext',
                name: 'Bild-Text-Box',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: false,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right'],
                    defaultType: 1
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'flexible',
                createHelp() {
                    return Vue.helpers.uiText('U038');
                },
                data(context) {
                    return {
                        title: 'Schreiben Sie einen Titel, der Ihr Modul am besten beschreibt',
                        subtitle: 'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                        text: 'Fassen Sie zusammen, worum es in dem Modul geht.',
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/gallery'),
                            pos: 1
                        }
                    };
                }
            },
            {
                type: 'imprint',
                name: 'Impressum',
                configurator: ['layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['imprint'],
                        basic: ['imprint']
                    },
                    onceOverall: true,
                    onceOnCurPage: true,
                    deletable: false,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return null;
                }
            },
            {
                type: 'jobs',
                name: 'Stellenanzeigen',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['jobs']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 7,
                            3: 3,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U028');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('jobs/title'),
                        subtitle: context.getters.getRandomTextInNamespace('jobs/subtitle'),
                        text: context.getters.getRandomTextInNamespace('jobs/text')
                    };
                },
                async afterCreation(id, context) {
                    // add default data for non preset
                    let data = context.getters.getProp('deha.user.misc.jobs');
                    if (data === undefined || data === null || data === '') {
                        await context.dispatch('setProp', {
                            source: 'deha.user.misc.jobs',
                            value: {
                                [getRandomId()]: {
                                    id: getLastId(),
                                    visible: true,
                                    data: {
                                        name: context.getters.getRandomTextInNamespace(
                                            'jobs/1/name'
                                        ),
                                        profile: context.getters.getRandomTextInNamespace(
                                            'jobs/1/profile'
                                        ),
                                        tasks: context.getters.getRandomTextInNamespace(
                                            'jobs/1/tasks'
                                        ),
                                        offer: context.getters.getRandomTextInNamespace(
                                            'jobs/1/offer'
                                        ),
                                        image: {
                                            id: context.getters.getRandomImageInNamespace(
                                                'images/jobs/default'
                                            ),
                                            pos: 1
                                        }
                                    }
                                },
                                [getRandomId()]: {
                                    id: getLastId(),
                                    visible: true,
                                    data: {
                                        name: context.getters.getRandomTextInNamespace(
                                            'jobs/2/name'
                                        ),
                                        profile: context.getters.getRandomTextInNamespace(
                                            'jobs/2/profile'
                                        ),
                                        tasks: context.getters.getRandomTextInNamespace(
                                            'jobs/2/tasks'
                                        ),
                                        offer: context.getters.getRandomTextInNamespace(
                                            'jobs/2/offer'
                                        ),
                                        image: {
                                            id: context.getters.getRandomImageInNamespace(
                                                'images/jobs/default'
                                            ),
                                            pos: 1
                                        }
                                    }
                                },
                                [getRandomId()]: {
                                    id: getLastId(),
                                    visible: true,
                                    data: {
                                        name: context.getters.getRandomTextInNamespace(
                                            'jobs/3/name'
                                        ),
                                        profile: context.getters.getRandomTextInNamespace(
                                            'jobs/3/profile'
                                        ),
                                        tasks: context.getters.getRandomTextInNamespace(
                                            'jobs/3/tasks'
                                        ),
                                        offer: context.getters.getRandomTextInNamespace(
                                            'jobs/3/offer'
                                        ),
                                        image: {
                                            id: context.getters.getRandomImageInNamespace(
                                                'images/jobs/default'
                                            ),
                                            pos: 1
                                        }
                                    }
                                }
                            }
                        });
                    }
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.jobs',
                        dataPreset: null,
                        moduleId: id,
                        default: 'all'
                    });
                }
            },
            {
                type: 'jobswidget',
                name: 'Stellenübersicht',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U028');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('jobswidget/title'),
                        subtitle: context.getters.getRandomTextInNamespace('jobswidget/subtitle'),
                        text: context.getters.getRandomTextInNamespace('jobswidget/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/jobswidget/bg'),
                            pos: 1
                        }
                    };
                }
            },
            {
                type: 'listing',
                name: 'Liste',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: false,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right'],
                    defaultType: 1
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'flexible',
                createHelp() {
                    return Vue.helpers.uiText('U040');
                },
                data(context) {
                    return {
                        title: 'Schreiben Sie einen Titel, der Ihr Modul am besten beschreibt',
                        subtitle: 'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                        text: 'Fassen Sie zusammen, worum es in dem Modul geht.',
                        items: {
                            [getRandomId()]: {
                                id: getLastId(),
                                data: {
                                    title: 'Schreiben Sie einen Titel',
                                    subtitle:
                                        'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                                    text:
                                        'Fassen Sie zusammen, worum es in dem Listenelemente geht.',
                                    image: {
                                        id: context.getters.getRandomImageInNamespace(
                                            'images/gallery'
                                        ),
                                        pos: 1
                                    }
                                },
                                visible: true
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                data: {
                                    title: 'Schreiben Sie einen Titel',
                                    subtitle:
                                        'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                                    text:
                                        'Fassen Sie zusammen, worum es in dem Listenelemente geht.',
                                    image: {
                                        id: context.getters.getRandomImageInNamespace(
                                            'images/gallery'
                                        ),
                                        pos: 1
                                    }
                                },
                                visible: true
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                data: {
                                    title: 'Schreiben Sie einen Titel',
                                    subtitle:
                                        'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                                    text:
                                        'Fassen Sie zusammen, worum es in dem Listenelemente geht.',
                                    image: {
                                        id: context.getters.getRandomImageInNamespace(
                                            'images/gallery'
                                        ),
                                        pos: 1
                                    }
                                },
                                visible: true
                            }
                        }
                    };
                }
            },
            {
                type: 'news',
                name: 'TECWORLD News',
                configurator: ['layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 2,
                            2: 7,
                            3: 2,
                            4: 4
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U021');
                }
            },
            {
                type: 'openingtimes',
                name: 'Öffnungszeiten',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: true
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 2,
                            2: 7,
                            3: 3,
                            4: 4
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U020');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('openingtimes/title'),
                        subtitle: context.getters.getRandomTextInNamespace('openingtimes/subtitle'),
                        text: context.getters.getRandomTextInNamespace('openingtimes/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/openingtimes/bg'),
                            pos: 1
                        }
                    };
                }
            },
            {
                type: 'partners',
                name: 'Partner',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 2,
                            2: 7,
                            3: 1,
                            4: 4
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U024');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('partners/title'),
                        subtitle: context.getters.getRandomTextInNamespace('partners/subtitle'),
                        text: context.getters.getRandomTextInNamespace('partners/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/partners/bg'),
                            pos: 1
                        }
                    };
                }
            },
            {
                type: 'privacy',
                name: 'Datenschutzerklärung',
                configurator: ['layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['privacy'],
                        basic: ['privacy']
                    },
                    onceOverall: true,
                    onceOnCurPage: true,
                    deletable: false,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return null;
                }
            },
            {
                type: 'references',
                name: 'Projekte',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['references']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 7,
                            3: 3,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U027');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('references/title'),
                        subtitle: context.getters.getRandomTextInNamespace('references/subtitle'),
                        text: context.getters.getRandomTextInNamespace('references/text')
                    };
                },
                async afterCreation(id, context) {
                    // add default data for non preset
                    let data = context.getters.getProp('deha.user.misc.references');
                    if (data === undefined || data === null || data === '') {
                        await context.dispatch('setProp', {
                            source: 'deha.user.misc.references',
                            value: {
                                [getRandomId()]: {
                                    id: getLastId(),
                                    visible: true,
                                    data: {
                                        name: 'Ihr Projekt',
                                        profile: context.getters.getRandomTextInNamespace(
                                            'references/profile'
                                        ),
                                        date_month: new Date().getMonth() + 1,
                                        date_year: new Date().getFullYear(),
                                        images: {
                                            image_0: {
                                                id: context.getters.getRandomImageInNamespace(
                                                    'images/references/default'
                                                )
                                            },
                                            image_1: {
                                                id: context.getters.getRandomImageInNamespace(
                                                    'images/references/default'
                                                )
                                            },
                                            image_2: {
                                                id: context.getters.getRandomImageInNamespace(
                                                    'images/references/default'
                                                )
                                            },
                                            image_3: {
                                                id: context.getters.getRandomImageInNamespace(
                                                    'images/references/default'
                                                )
                                            }
                                        }
                                    }
                                }
                            }
                        });
                    }
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.references',
                        dataPreset: null,
                        moduleId: id,
                        default: 'all'
                    });
                }
            },
            {
                type: 'referenceswidget',
                name: 'Projektübersicht',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 2,
                            2: 7,
                            3: 3,
                            4: 4
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U027');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('referenceswidget/title'),
                        subtitle: context.getters.getRandomTextInNamespace(
                            'referenceswidget/subtitle'
                        ),
                        text: context.getters.getRandomTextInNamespace('referenceswidget/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace(
                                'images/referenceswidget/bg'
                            ),
                            pos: 1
                        }
                    };
                }
            },
            {
                type: 'sectors',
                name: 'Leistungsfelder',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['sectors']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 7,
                            3: 3,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U019');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/text')
                    };
                },
                async afterCreation(id, context) {
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.sectors',
                        dataPreset: 'Listpresets.sectors',
                        moduleId: id
                    });
                }
            },
            {
                type: 'sectorswidget',
                name: 'Leistungsübersicht',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: true
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme, page) => {
                        if (page === 'home') {
                            return {
                                1: 1,
                                2: 6,
                                3: 1,
                                4: 3
                            }[theme];
                        }
                        return {
                            1: 1,
                            2: 7,
                            3: 3,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U019');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectorswidget/title'),
                        subtitle: context.getters.getRandomTextInNamespace(
                            'sectorswidget/subtitle'
                        ),
                        text: context.getters.getRandomTextInNamespace('sectorswidget/text')
                    };
                },
                async afterCreation(id, context) {
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.sectors',
                        dataPreset: 'Listpresets.sectors',
                        moduleId: id
                    });
                }
            },
            {
                type: 'services',
                name: 'Dienstleistungen',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'sectors']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: true
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme, page) => {
                        if (page === 'home') {
                            return {
                                1: 2,
                                2: 7,
                                3: 3,
                                4: 4
                            }[theme];
                        }
                        return {
                            1: 1,
                            2: 7,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U026');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('services/title'),
                        subtitle: context.getters.getRandomTextInNamespace('services/subtitle'),
                        text: context.getters.getRandomTextInNamespace('services/text')
                    };
                },
                async afterCreation(id, context) {
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.services',
                        dataPreset: 'Listpresets.services',
                        moduleId: id
                    });
                }
            },
            {
                type: 'socials',
                name: 'Soziale Medien',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 3,
                            2: 3,
                            3: 3,
                            4: 5
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U033');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('socials/title'),
                        subtitle: context.getters.getRandomTextInNamespace('socials/subtitle')
                    };
                },
                async afterCreation(id, context) {
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.socials',
                        dataPreset: 'Listpresets.socials',
                        moduleId: id,
                        default: 'none'
                    });
                }
            },
            {
                type: 'team',
                name: 'Team',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['team']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 7,
                            3: 3,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U029');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('team/title'),
                        subtitle: context.getters.getRandomTextInNamespace('team/subtitle'),
                        text: context.getters.getRandomTextInNamespace('team/text')
                    };
                },
                async afterCreation(id, context) {
                    // add default data for non preset
                    let data = context.getters.getProp('deha.user.misc.team');
                    if (data === undefined || data === null || data === '') {
                        await context.dispatch('setProp', {
                            source: 'deha.user.misc.team',
                            value: {
                                [getRandomId()]: {
                                    id: getLastId(),
                                    visible: true,
                                    data: {
                                        name:
                                            context.getters.getProp(
                                                'deha.user.misc.contact_person.first_name'
                                            ) +
                                            ' ' +
                                            context.getters.getProp(
                                                'deha.user.misc.contact_person.last_name'
                                            ),
                                        position: 'Geschäftsführer',
                                        location: context.getters.getProp('deha.user.ort'),
                                        email: context.getters.getProp('deha.user.email'),
                                        phone: context.getters.getProp('deha.user.telefon'),
                                        image: {
                                            id: context.getters.getRandomImageInNamespace(
                                                'images/team/default'
                                            ),
                                            pos: 1
                                        }
                                    }
                                }
                            }
                        });
                    }
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.jobs',
                        dataPreset: null,
                        moduleId: id,
                        default: 'all'
                    });
                }
            },
            {
                type: 'teamwidget',
                name: 'Teamübersicht',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5, 6],
                    align: ['left', 'center', 'right']
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U029');
                },
                data(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('teamwidget/title'),
                        subtitle: context.getters.getRandomTextInNamespace('teamwidget/subtitle'),
                        text: context.getters.getRandomTextInNamespace('teamwidget/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/teamwidget/bg'),
                            pos: 1
                        }
                    };
                }
            },
            {
                type: 'textbox',
                name: 'Text-Box',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: false,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3],
                    align: ['left', 'center', 'right'],
                    defaultType: 3
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 6,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'flexible',
                createHelp() {
                    return Vue.helpers.uiText('U039');
                },
                data() {
                    return {
                        texts: {
                            [getRandomId()]: {
                                id: getLastId(),
                                data: {
                                    title:
                                        'Schreiben Sie einen Titel, der Ihr Textelement am besten beschreibt',
                                    subtitle:
                                        'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                                    text: 'Fassen Sie zusammen, worum es in dem Textelement geht.'
                                },
                                visible: true
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                data: {
                                    title:
                                        'Schreiben Sie einen Titel, der Ihr Textelement am besten beschreibt',
                                    subtitle:
                                        'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                                    text: 'Fassen Sie zusammen, worum es in dem Textelement geht.'
                                },
                                visible: true
                            },
                            [getRandomId()]: {
                                id: getLastId(),
                                data: {
                                    title:
                                        'Schreiben Sie einen Titel, der Ihr Textelement am besten beschreibt',
                                    subtitle:
                                        'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                                    text: 'Fassen Sie zusammen, worum es in dem Textelement geht.'
                                },
                                visible: true
                            }
                        }
                    };
                }
            },
            {
                type: 'video',
                name: 'Video',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: false,
                    basic: true,
                    pages: {
                        starter: [],
                        basic: []
                        // hide module
                        //basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: false,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2, 3, 4, 5],
                    align: [],
                    defaultType: 1
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 1,
                            2: 7,
                            3: 1,
                            4: 3
                        }[theme];
                    }
                },
                group: 'flexible',
                createHelp() {
                    return Vue.helpers.uiText('U036');
                },
                data() {
                    return {
                        source: 'https://vimeo.com/330706510',
                        title: 'Schreiben Sie einen Titel, der Ihr Video am besten beschreibt',
                        subtitle: 'Schreiben Sie einen Untertitel, der die Überschrift ergänzt',
                        text: 'Fassen Sie zusammen, worum es in dem Video geht.'
                    };
                }
            },
            {
                type: 'widgets',
                name: 'Widgets',
                configurator: ['data', 'layout', 'appearance'],
                restrictions: {
                    starter: true,
                    basic: true,
                    pages: {
                        starter: ['home'],
                        basic: ['home', 'about', 'team', 'sectors', 'references', 'jobs', 'contact']
                    },
                    onceOverall: false,
                    onceOnCurPage: true,
                    deletable: true,
                    showInStarterMenu: false
                },
                layout: {
                    types: [1, 2],
                    align: [],
                    defaultType: 1
                },
                appearance: {
                    colors: [1, 2, 3, 4, 5, 6, 7],
                    defaultColor: (theme) => {
                        return {
                            1: 2,
                            2: 2,
                            3: 2,
                            4: 2
                        }[theme];
                    }
                },
                group: 'smart',
                createHelp() {
                    return Vue.helpers.uiText('U041');
                },
                data() {
                    return {
                        title: 'TECWORLD Widgets'
                    };
                },
                async afterCreation(id, context) {
                    await context.dispatch('initOrUpdateList', {
                        dataSource: 'deha.user.misc.widgets',
                        dataPreset: 'Listpresets.widgets',
                        moduleId: id,
                        default: 'none'
                    });
                }
            }
        ]
    },
    mutations: {},
    getters: {
        getModules(state, getters, rootState) {
            if (rootState.tecpage.user && rootState.tecpage.user.modules) {
                return rootState.tecpage.user.modules;
            }
            return null;
        },
        getActiveModuleType(state, getters) {
            if (getters.getActiveModule) {
                return getters.getActiveModule.type;
            }
            return null;
        },
        getActiveModuleId(state, getters, rootState) {
            if (rootState.route.query.module_id) {
                return rootState.route.query.module_id;
            }
            return null;
        },
        getActiveModule(state, getters, rootState) {
            if (getters.getActiveModuleId !== null) {
                let id = getters.getActiveModuleId;
                if (rootState.tecpage.user && rootState.tecpage.user.modules) {
                    return rootState.tecpage.user.modules[id];
                }
            }
            return null;
        },
        moduleExists(state, getters, rootState) {
            return (id) => {
                return id in rootState.tecpage.user.modules;
            };
        },
        getModuleById(state, getters) {
            return (id) => {
                if (id === undefined || id === null || id === '') {
                    return null;
                }
                return getters.getProp('tecpage.user.modules.' + id);
            };
        },
        isModuleDeletable(state, getters) {
            return (id) => {
                let item = getters.getProp('tecpage.user.modules' + '.' + id);
                if (item === undefined) {
                    return false;
                }
                let data = getters.getModuleDataByType(item.type);
                if (data === undefined) {
                    return false;
                }
                return data.restrictions.deletable;
            };
        },
        getActiveModuleLayoutTypes(state, getters) {
            let module = getters.getActiveModule;
            if (module !== null) {
                return cloneDeep(state.modules).find((i) => i.type === module.type).layout.types;
            }
            return null;
        },
        getActiveModuleLayoutAlign(state, getters) {
            let module = getters.getActiveModule;
            if (module !== null) {
                return cloneDeep(state.modules).find((i) => i.type === module.type).layout.align;
            }
            return null;
        },
        getActiveModuleAppearanceColors(state, getters) {
            let module = getters.getActiveModule;
            if (module !== null) {
                let colors = cloneDeep(state.modules).find((i) => i.type === module.type).appearance
                    .colors;
                let obj = {};
                colors.forEach((colors__value) => {
                    obj[colors__value] = 'Variante ' + colors__value;
                });
                return obj;
            }
            return null;
        },
        getModuleDataByType(state) {
            return (type) => {
                return cloneDeep(state.modules).find((i) => i.type === type);
            };
        },
        getModuleByPageAndType(state, getters, rootState) {
            return (page_type, module_type) => {
                let page_id = getters.getPageIdFromType(page_type);
                if (page_id === undefined || page_id === null) {
                    return null;
                }
                if (rootState.tecpage.user && rootState.tecpage.user.modules) {
                    let page = Object.values(rootState.tecpage.user.modules).find(
                        (i) => i.type === module_type && i.page_id === page_id
                    );
                    if (page !== undefined) {
                        return page;
                    }
                }
                return null;
            };
        },
        getPossibleModulesToCreate(state, getters) {
            let modules = [],
                curPage = getters.getActivePageId,
                curPageType = getters.getActivePageType,
                hasPackageBasic = getters.hasPackageBasic,
                modulesAll = getters.getModules;
            state.modules.forEach((data__value) => {
                let countOverall =
                        modulesAll === null
                            ? 0
                            : Object.values(modulesAll).filter((i) => i.type === data__value.type)
                                  .length,
                    countOnCurPage =
                        modulesAll === null
                            ? 0
                            : Object.values(modulesAll).filter(
                                  (i) => i.type === data__value.type && i.page_id === curPage
                              ).length;
                if (
                    curPageType !== 'free' &&
                    (!data__value.restrictions.pages[
                        !hasPackageBasic ? 'starter' : 'basic'
                    ].includes(curPageType) ||
                        (data__value.restrictions.starter === false && !hasPackageBasic === true) ||
                        (data__value.restrictions.basic === false && hasPackageBasic === true) ||
                        (data__value.restrictions.onceOverall === true && countOverall > 0) ||
                        (data__value.restrictions.onceOnCurPage === true && countOnCurPage > 0))
                ) {
                    return;
                }
                modules.push(data__value);
            });
            if (modules.length === 0) {
                return null;
            }
            return modules;
        },
        generateClassForModule(state, getters) {
            return (id) => {
                let module = getters.getModuleById(id),
                    classes = {};
                classes['module'] = true;
                classes['module-' + module.type] = true;
                classes['bg-color'] = true;
                classes['color-p'] = true;
                if (getters.getActiveModuleId === id) {
                    classes['module--active'] = true;
                }
                if (module.appearance && module.appearance.color) {
                    classes['module--color-' + module.appearance.color] = true;
                }
                if (module.layout && module.layout.align) {
                    classes['module--align-' + module.layout.align] = true;
                    classes['module-' + module.type + '--align-' + module.layout.align] = true;
                }
                if (module.layout && module.layout.type) {
                    classes['module-' + module.type + '--layout-' + module.layout.type] = true;
                }
                if (['sectors', 'jobs', 'references', 'team'].includes(module.type)) {
                    classes['module--big'] = true;
                    classes['bg-color'] = false;
                    classes['color-p'] = false;
                    classes['module--color-' + module.appearance.color] = false;
                }
                return classes;
            };
        },
        getModuleBackground(state, getters) {
            return (id) => {
                let module = getters.getModuleById(id);
                if (module === null) {
                    return null;
                }
                if (
                    'appearance' in module &&
                    'background' in module.appearance &&
                    'active' in module.appearance.background &&
                    module.appearance.background.active == '1' &&
                    'image' in module.appearance.background &&
                    module.appearance.background.image != ''
                ) {
                    return module.appearance.background.image;
                }
                return null;
            };
        }
    },
    actions: {
        async removeModule(context, { confirm, id, route, save }) {
            if (confirm === true) {
                await context.dispatch('routeRemoveQuery', [
                    'textpicker',
                    'textpicker_namespace',
                    'filemanager',
                    'filemanager_source',
                    'filemanager_accept',
                    'filemanager_multiple',
                    'fileeditor',
                    'fileeditor_file_id'
                ]);
                EventBus.$emit('controlhead-remove-open', context.getters.getCurrentRouteFullPath);
                EventBus.$once('controlhead-remove-accepted', async () => {
                    await context.dispatch('removeModule', {
                        confirm: false,
                        id: id,
                        route: route,
                        save: save
                    });
                });
                EventBus.$once('controlhead-remove-denied', () => {});
            } else {
                if (route === true) {
                    /* clear differ for route */
                    await context.dispatch(
                        'forgetDifferInRoute',
                        context.getters.getCurrentRouteFullPath
                    );
                    await context.dispatch('routeRemoveAllQueries');
                }
                await context.dispatch('removeProp', {
                    source: 'tecpage.user.modules.' + id
                });
                if (save === true) {
                    await context.dispatch('saveAllData');
                    success('Erfolgreich gelöscht');
                }
            }
        },
        async createModule(context, payload) {
            let newId = pushid(),
                modules = context.getters.getProp('tecpage.user.modules'),
                moduleData = context.getters.getModuleDataByType(payload.type),
                page_id =
                    'page_id' in payload &&
                    payload.page_id !== undefined &&
                    payload.page_id !== null
                        ? payload.page_id
                        : context.getters.getActivePageId,
                name = 'name' in payload ? payload.name : moduleData.name,
                pageType = context.getters.getPageTypeFromId(page_id),
                activeTheme = context.getters.getActiveTheme;

            let pos;
            if (
                'insertAfter' in payload &&
                payload.insertAfter !== undefined &&
                payload.insertAfter !== null
            ) {
                pos = Object.values(modules).find((el) => el.id === payload.insertAfter).pos;
            } else if ('pos' in payload) {
                pos = payload.pos;
            } else {
                pos = 999;
            }
            pos += 0.1; // positions get reindexed after creation

            let data = {};
            if ('data' in moduleData) {
                data = moduleData.data(context);
            }

            let layout = {};
            if ('layout' in payload) {
                layout = payload.layout;
            } else {
                layout = {
                    align: moduleData.layout.align[0],
                    type:
                        moduleData.layout.defaultType !== undefined
                            ? moduleData.layout.defaultType
                            : random(moduleData.layout.types)
                };
            }

            let appearance = {};
            if ('appearance' in payload) {
                appearance = payload.appearance;
            } else {
                appearance = {
                    color: moduleData.appearance.defaultColor(activeTheme, pageType)
                };
            }

            let newItem = {
                id: newId,
                type: payload.type,
                name: name,
                pos: pos,
                data: data,
                layout: layout,
                appearance: appearance,
                page_id: page_id
            };
            await context.dispatch('setProp', {
                source: 'tecpage.user.modules.' + newId,
                value: newItem
            });
            await context.dispatch('reindexModulePositions', {
                page_id: page_id
            });
            /* after creation triggers */
            if ('afterCreation' in moduleData) {
                await moduleData.afterCreation(newId, context);
            }
            if ('route' in payload && payload.route === true) {
                await context.dispatch('closeModulecreator');
                if (moduleData.configurator.includes('data')) {
                    await context.dispatch('routeAddQuery', {
                        configurator: 1,
                        configurator_group: 'modules',
                        configurator_view: 'data',
                        module_id: newId
                    });
                    context.dispatch('addDifferCreatedModule', {
                        id: newId,
                        route: context.getters.getCurrentRouteFullPath
                    });
                    context.dispatch('scrollVerticalCenterModule', {
                        id: newId
                    });
                }
            }
            return newId;
        },
        async setColorAppearanceForModules(context) {
            let modules = context.getters.getModules,
                activeTheme = context.getters.getActiveTheme;
            for (let modules__value of Object.values(modules)) {
                let moduleData = context.getters.getModuleDataByType(modules__value.type),
                    pageType = context.getters.getPageTypeFromId(modules__value.page_id),
                    color = moduleData.appearance.defaultColor(activeTheme, pageType);
                await context.dispatch('setProp', {
                    source: 'tecpage.user.modules.' + modules__value.id + '.appearance.color',
                    value: color
                });
            }
        },
        async changeCompanyNameInAllModules(context, payload) {
            if (payload.search === payload.replace) {
                return;
            }
            for (const [key, value] of Object.entries({
                'tecpage.user.modules': context.getters.getModules,
                'deha.user.misc': context.getters.getUserMisc
            })) {
                await context.dispatch('changeCompanyNameInAllModulesTraverse', {
                    key: key,
                    value: value,
                    path: '',
                    search: payload.search,
                    replace: payload.replace
                });
            }
        },
        async changeCompanyNameInAllModulesTraverse(context, payload) {
            let companyForms = context.getters.getProp('Data.companyForms');
            if (payload.value === null || payload.value === undefined || payload.value == '') {
                return;
            } else if (typeof payload.value === 'string' || payload.value instanceof String) {
                if (payload.value.indexOf(payload.search) === -1) {
                    return;
                }
                let val = payload.value,
                    searchIsW = companyForms.some((i) => payload.search.indexOf(i) > -1),
                    replaceIsW = companyForms.some((i) => payload.replace.indexOf(i) > -1);
                if (searchIsW === replaceIsW) {
                    val = val.split(payload.search).join(payload.replace);
                }
                if (searchIsW === true && replaceIsW === false) {
                    val = val.split(payload.search).join(payload.replace);
                    // <<FIRMENNAME_PREFIX_3>>
                    val = val.split('die ' + payload.replace).join(payload.replace);
                    // <<FIRMENNAME_PREFIX_2>>
                    val = val.split('Die ' + payload.replace).join(payload.replace);
                    // <<FIRMENNAME_PREFIX_4>>
                    val = val.split('Bei der ' + payload.replace).join('Bei ' + payload.replace);
                    val = val.split('bei der ' + payload.replace).join('bei ' + payload.replace);
                    val = val.split('Von der ' + payload.replace).join('Von ' + payload.replace);
                    val = val.split('von der ' + payload.replace).join('von ' + payload.replace);
                    // <<FIRMENNAME_PREFIX_1>>
                    val = val.split('der ' + payload.replace).join('von ' + payload.replace);
                }
                if (searchIsW === false && replaceIsW === true) {
                    val = val.split(payload.search).join(payload.replace);
                    // <<FIRMENNAME_PREFIX_2>>
                    if (val.indexOf(payload.replace) === 0) {
                        val = 'Die ' + val;
                    }
                    val = val.split('. ' + payload.replace).join('. Die ' + payload.replace);
                    // <<FIRMENNAME_PREFIX_1>>
                    // <<FIRMENNAME_PREFIX_4>>
                    val = val.split('Bei ' + payload.replace).join('Bei der ' + payload.replace);
                    val = val.split('bei ' + payload.replace).join('bei der ' + payload.replace);
                    val = val.split('Von ' + payload.replace).join('Von der ' + payload.replace);
                    val = val.split('von ' + payload.replace).join('von der ' + payload.replace);
                    // <<FIRMENNAME_PREFIX_3>>
                    val = val.split('über ' + payload.replace).join('über die ' + payload.replace);
                    val = val.split('ist ' + payload.replace).join('ist die ' + payload.replace);
                }
                await context.dispatch('setProp', {
                    source: payload.path + '.' + payload.key,
                    value: val
                });
            } else if (typeof payload.value === 'object') {
                for (const [data__key, data__value] of Object.entries(payload.value)) {
                    await context.dispatch('changeCompanyNameInAllModulesTraverse', {
                        key: data__key,
                        value: data__value,
                        path: payload.path + (payload.path === '' ? '' : '.') + payload.key,
                        search: payload.search,
                        replace: payload.replace
                    });
                }
            }
        },
        async setPosForModule(context, payload) {
            await context.dispatch('setProp', {
                source: 'tecpage.user.modules.' + payload.id + '.pos',
                value: payload.pos
            });
            await context.dispatch('reindexModulePositions');
        },
        async reindexModulePositions(context, payload = {}) {
            if (!('page_id' in payload)) {
                payload.page_id = context.getters.getActivePageId;
            }
            let modules = toArray(context.getters.getProp('tecpage.user.modules'))
                    .filter((i) => i.page_id === payload.page_id)
                    .sort((a, b) => a.pos - b.pos),
                posCur = 1;
            modules.forEach((modules__value) => {
                context.dispatch('setProp', {
                    source: 'tecpage.user.modules.' + modules__value.id + '.pos',
                    value: posCur
                });
                posCur++;
            });
        },
        async setSpecialGalleryLink(context, { slide_index, page_type }) {
            // set special gallery link
            let module = context.getters.getModuleByPageAndType('home', 'gallery'),
                page_id = context.getters.getPageIdFromType(page_type),
                page = context.getters.getPageFromId(page_id);
            if (
                module !== null &&
                module.data.slides !== null &&
                module.data.slides !== undefined &&
                module.data.slides !== '' &&
                typeof Object.keys(module.data.slides)[slide_index] !== 'undefined'
            ) {
                let slide_key = Object.keys(module.data.slides)[slide_index],
                    slide_link = module.data.slides[slide_key].data.link;
                if (
                    slide_link === null ||
                    slide_link === undefined ||
                    slide_link === '' ||
                    Object.keys(slide_link).length === 0 ||
                    slide_link.active === false
                ) {
                    await context.dispatch('setProp', {
                        source:
                            'tecpage.user.modules.' +
                            module.id +
                            '.data.slides.' +
                            slide_key +
                            '.data.link',
                        value: {
                            active: true,
                            page_id: page_id,
                            text: page.title,
                            url: null
                        }
                    });
                }
            }
        },
        async createDefaultModulesForPage(context, payload) {
            let type = context.getters.getPageTypeFromId(payload.page_id),
                page_id = payload.page_id;
            if (type === 'home') {
                await context.dispatch('createModule', {
                    type: 'gallery',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 3
                    }
                });
                await context.dispatch('createModule', {
                    type: 'services',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 5
                    }
                });
                await context.dispatch('createModule', {
                    type: 'sectorswidget',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 1
                    }
                });
                await context.dispatch('createModule', {
                    type: 'certifications',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 4
                    }
                });
                await context.dispatch('createModule', {
                    type: 'about',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 1
                    }
                });
                await context.dispatch('createModule', {
                    type: 'openingtimes',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 3
                    }
                });
                await context.dispatch('createModule', {
                    type: 'brands',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 2
                    }
                });
                await context.dispatch('createModule', {
                    type: 'contact',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 4
                    }
                });
                if (context.getters.getListItems('deha.user.misc.socials').length > 0) {
                    await context.dispatch('createModule', {
                        type: 'socials',
                        page_id: page_id,
                        layout: {
                            align: 'left',
                            type: 2
                        }
                    });
                }
                await context.dispatch('createModule', {
                    type: 'news',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 1
                    }
                });
            }
            if (type === 'imprint') {
                await context.dispatch('createModule', {
                    type: 'imprint',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 1
                    }
                });
            }
            if (type === 'privacy') {
                await context.dispatch('createModule', {
                    type: 'privacy',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 1
                    }
                });
            }
            if (type === 'sectors') {
                await context.dispatch('createModule', {
                    type: 'sectors',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 3
                    }
                });
                await context.dispatch('createModule', {
                    type: 'services',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 2
                    }
                });
                await context.dispatch('createModule', {
                    type: 'brands',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 1
                    }
                });
                await context.dispatch('createModule', {
                    type: 'contactwidget',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 5
                    }
                });
                await context.dispatch('setSpecialGalleryLink', {
                    slide_index: 0,
                    page_type: 'sectors'
                });
            }
            if (type === 'jobs') {
                await context.dispatch('createModule', {
                    type: 'jobs',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 3
                    }
                });
                await context.dispatch('createModule', {
                    type: 'jobswidget',
                    page_id: context.getters.getPageIdFromType('home'),
                    pos: 6,
                    layout: {
                        align: 'center',
                        type: 1
                    }
                });
                if (context.getters.getListItems('deha.user.misc.socials').length > 0) {
                    await context.dispatch('createModule', {
                        type: 'socials',
                        page_id: page_id,
                        layout: {
                            align: 'left',
                            type: 2
                        }
                    });
                }
                await context.dispatch('createModule', {
                    type: 'contactwidget',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 5
                    }
                });
            }
            if (type === 'about') {
                await context.dispatch('createModule', {
                    type: 'about',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 4
                    }
                });
                await context.dispatch('createModule', {
                    type: 'awards',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 4
                    }
                });
                await context.dispatch('createModule', {
                    type: 'documents',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 6
                    }
                });
                await context.dispatch('createModule', {
                    type: 'partners',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 3
                    }
                });
                await context.dispatch('createModule', {
                    type: 'certifications',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 4
                    }
                });
                await context.dispatch('createModule', {
                    type: 'contactwidget',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 5
                    }
                });
                let moduleToDelete = context.getters.getModuleByPageAndType('home', 'about');
                if (moduleToDelete !== null) {
                    await context.dispatch('removeModule', {
                        id: moduleToDelete.id,
                        confirm: false,
                        route: false,
                        save: false
                    });
                }
                await context.dispatch('createModule', {
                    type: 'aboutwidget',
                    page_id: context.getters.getPageIdFromType('home'),
                    layout: {
                        align: 'center',
                        type: 1
                    },
                    pos: 5 - 0.1
                });
                await context.dispatch('reindexModulePositions');

                await context.dispatch('setSpecialGalleryLink', {
                    slide_index: 1,
                    page_type: 'about'
                });
            }
            if (type === 'team') {
                await context.dispatch('createModule', {
                    type: 'team',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 1
                    }
                });
                await context.dispatch('createModule', {
                    type: 'certifications',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 5
                    }
                });
                await context.dispatch('createModule', {
                    type: 'aboutwidget',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 2
                    }
                });
                await context.dispatch('createModule', {
                    type: 'contactwidget',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 6
                    }
                });
                await context.dispatch('createModule', {
                    type: 'teamwidget',
                    page_id: context.getters.getPageIdFromType('home'),
                    pos: 8,
                    layout: {
                        align: 'center',
                        type: 5
                    }
                });
            }
            if (type === 'references') {
                await context.dispatch('createModule', {
                    type: 'references',
                    page_id: page_id,
                    layout: {
                        align: 'left',
                        type: 1
                    }
                });
                await context.dispatch('createModule', {
                    type: 'sectorswidget',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 5
                    }
                });
                await context.dispatch('createModule', {
                    type: 'contactwidget',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 5
                    }
                });
                await context.dispatch('createModule', {
                    type: 'referenceswidget',
                    page_id: context.getters.getPageIdFromType('home'),
                    pos: 9,
                    layout: {
                        align: 'left',
                        type: 4
                    }
                });
            }
            if (type === 'contact') {
                await context.dispatch('createModule', {
                    type: 'contact',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 4
                    }
                });
                await context.dispatch('createModule', {
                    type: 'contactform',
                    page_id: page_id,
                    layout: {
                        align: 'center',
                        type: 3
                    }
                });
                if (context.getters.getListItems('deha.user.misc.socials').length > 0) {
                    await context.dispatch('createModule', {
                        type: 'socials',
                        page_id: page_id,
                        layout: {
                            align: 'left',
                            type: 2
                        }
                    });
                }
                let moduleToDelete = context.getters.getModuleByPageAndType('home', 'contact');
                if (moduleToDelete !== null) {
                    await context.dispatch('removeModule', {
                        id: moduleToDelete.id,
                        confirm: false,
                        route: false,
                        save: false
                    });
                }
                await context.dispatch('createModule', {
                    type: 'contactwidget',
                    page_id: context.getters.getPageIdFromType('home'),
                    layout: {
                        align: 'center',
                        type: 5
                    },
                    pos: 10 - 0.1
                });
                await context.dispatch('reindexModulePositions');

                await context.dispatch('setSpecialGalleryLink', {
                    slide_index: 2,
                    page_type: 'contact'
                });
            }
        }
    }
};
